import React from "react";
import { motion } from "framer-motion";
import FadeInView from "./FadeInView";

export default function NewLandingModeCards() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="mode-section" id="mode-section">
      <div className="mode-section-inner">
        <FadeInView>
          <p className="section-label">How It Works</p>
          <h2 className="section-title">Choose How You Want to Strengthen Your Case.</h2>
        </FadeInView>
        <div className="mode-cards">
          <motion.div
            className="mode-card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            whileHover={{ y: -4 }}
          >
            <span className="mode-card-badge">Research Mode</span>
            <h3>Multi-AI Legal Research</h3>
            <p>
              Run your legal question through multiple AI models simultaneously.
              LawFusion compares the responses, highlights agreement and
              disagreement, surfaces gaps, and helps you identify the strongest
              path forward.
            </p>
            <button
              type="button"
              className="btn-card nl-btn-unstyled"
              onClick={() => scrollTo("research-preview")}
            >
              See Research Mode →
            </button>
          </motion.div>
          <motion.div
            className="mode-card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            whileHover={{ y: -4 }}
          >
            <span className="mode-card-badge">Debate Mode</span>
            <h3>Adversarial Argument Testing</h3>
            <p>
              LawFusion assigns AI roles — Advocate, Critic, and Strategist —
              then runs a structured debate to expose weak spots before opposing
              counsel does.
            </p>
            <button
              type="button"
              className="btn-card nl-btn-unstyled"
              onClick={() => scrollTo("debate-preview")}
            >
              See Debate Mode →
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
